import Image from "@/shared/components/Image/new";
import styles from "./styles.module.css"; // ¡Necesitaremos editar este archivo!
import { loader } from "@/shared/functions/getImagesFunctions";
import { formatAuthorNames } from '@/shared/functions/formatAthorNames';
import { EnVivo } from "@/shared/components/enVivo";
import VideoLoop from "@/shared/components/VideoLoop";
import React from "react"; 

const NotaAperturaHorizontal = (props) => {
    const { title, author, summary, url, images, subtitle, hasBackground, metadata, croppedImages = [], videosOpenLoop = {}} = props;
    
    const authorsToRender = author?.slice(0, 2) || [];
    const noTagsHtml = summary && summary.length ? summary.replace(/<[^>]+>/g, '').replace(/&nbsp[;]?/ig, ' ') : null;
    const MAIN_CROP = '3_2_300x200';
    const SECONDARY_CROP = '3_2_300x200';
    const manualClippingMobile = croppedImages && croppedImages.filter(el => el.id === "Mobile")?.[0]
    const manualClippingMobileUrl = manualClippingMobile?.url ?? null;
    const manualClippingDesktop = croppedImages && croppedImages.filter(el => el.id === "Desktop")?.[0]
    const defaultImage = `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}/img/default.png`
    const imageUrl = images?.[0] && `${manualClippingDesktop ? manualClippingDesktop?.url : images[0]?.url}`
    const imageTitle = images?.[0] && images[0]?.title
    let imagenMobile = SECONDARY_CROP;
    if (manualClippingMobileUrl) {
        imagenMobile = manualClippingMobileUrl;
    } 

    return (
        <div className={`${styles["contenedor-nota-horizontal"]} ${styles["shell-container"]}`}>
            
            <a href={url} className={styles["overlay-link"]} aria-label={title}></a>

            <div className={styles["nota-container"]}>
                <div className={`${styles["img-container"]}`}>
                    {
                        videosOpenLoop?.enabled
                        ? <VideoLoop videoLoop={videosOpenLoop}/>
                        : <Image
                            src={!imageUrl ? defaultImage : imageUrl}
                            alt={imageTitle}
                            clipping={MAIN_CROP}
                            width={300}
                            height={200}
                            className={styles['img']}
                            srcSet={{ mobile: imagenMobile }}
                          />
                    }
                     {metadata && metadata.typeWeb && metadata.typeWeb === "live_blog" && <EnVivo data-testid='envivo'/>}
                     {metadata && metadata.sponsored  && <div className={`${styles["patrocinado"]}`}>patrocinado</div>}
                </div>
                <div className={`${styles["nota-derecha"]}`}> 
                    <div className={`${styles["nota-container-text"]}`}>
                        
                        <h2>
                            {subtitle && (
                                <span className={`${styles["blue-txt"]}`}>
                                    {subtitle}
                                </span>
                            )}
                            {subtitle && ' '}
                            {title}
                        </h2>

                        {noTagsHtml && (
                            <div className={
                                hasBackground
                                    ? `${styles["background"]} ${styles["nota-summary"]}`
                                    : `${styles["nota-summary"]}`}
                            >
                                {noTagsHtml}
                            </div>
                        )}
                     
                        {authorsToRender.length > 0 && (
                            <div className={`${styles["nota-autor"]} ${styles["author-link-area"]}`}>
                                Por{' '}
                                {authorsToRender.map((auth, index) => {
                                    const authorName = formatAuthorNames(auth.name).replace(/<[^>]+>/g, '');
                                    
                                    return (
                                        <React.Fragment key={auth.slug || authorName}>
                                            {auth.slug ? (
                                                <a href={`/autor/${auth.slug}`}>{authorName}</a>
                                            ) : (
                                                authorName
                                            )}
                                            {index < authorsToRender.length - 1 && ' - '}
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotaAperturaHorizontal;